<script setup>
defineProps({
  label: { type: String, default: "" },
  labelFor: { type: String, default: undefined },
  error: { type: String, default: "" },
  hint: { type: String, default: "" },
  required: { type: Boolean, default: false },
});
</script>

<template>
  <div class="ca-form-group">
    <!-- Label row -->
    <label
      v-if="label || $slots.label"
      class="ca-label"
      :for="labelFor"
    >
      <slot name="label">{{ label }}</slot>
      <span v-if="required" aria-hidden="true">&thinsp;*</span>
    </label>

    <!-- Input/control slot -->
    <slot />

    <!-- Hint text (shown when no error) -->
    <span v-if="hint && !error" class="ca-form-hint">{{ hint }}</span>

    <!-- Error message -->
    <span v-if="error" class="ca-form-error" role="alert">{{ error }}</span>
  </div>
</template>
